import "./BookmarksPage.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAllBookmarks } from "../../api";

export default function BookmarksPage() {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAllBookmarks()
      .then(({ data }) => setGroups(data))
      .catch(() => setGroups([]))
      .finally(() => setLoading(false));
  }, []);

  const hasBookmarks = groups.length > 0;

  return (
    <div className="bm-page">
      <div className="bm-page__inner">
        <button
          className="bm-page__back"
          onClick={() => navigate("/courses")}
          aria-label="Back to courses"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M10 3L5 8l5 5"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Back to courses
        </button>

        <h1 className="bm-page__title">
          <svg
            width="22"
            height="22"
            viewBox="0 0 14 14"
            fill="none"
            aria-hidden="true"
            className="bm-page__title-icon"
          >
            <path
              d="M3 2h8v10L7 9.5 3 12V2z"
              stroke="currentColor"
              strokeWidth="1.4"
              strokeLinejoin="round"
            />
          </svg>
          My Bookmarks
        </h1>

        {loading && <p className="bm-page__status">Loading bookmarks…</p>}

        {!loading && !hasBookmarks && (
          <div className="bm-page__empty">
            <svg
              width="48"
              height="48"
              viewBox="0 0 14 14"
              fill="none"
              aria-hidden="true"
              className="bm-page__empty-icon"
            >
              <path
                d="M3 2h8v10L7 9.5 3 12V2z"
                stroke="currentColor"
                strokeWidth="1.1"
                strokeLinejoin="round"
              />
            </svg>
            <p className="bm-page__empty-heading">No bookmarks yet</p>
            <p className="bm-page__empty-body">
              While reading a course, highlight any text or equationand click bookmark to save this place. 
              Your bookmarks will appear
              here, organised by course, as clickable links that jump straight
              back to that spot.
            </p>
          </div>
        )}

        {!loading && hasBookmarks && (
          <div className="bm-page__groups">
            {groups.map((group) => (
              <section key={group.courseId} className="bm-page__group">
                <h2 className="bm-page__group-title">{group.courseTitle}</h2>
                <ul className="bm-page__list">
                  {group.bookmarks.map((bm) => (
                    <li key={bm._id} className="bm-page__item">
                      <button
                        className="bm-page__link"
                        onClick={() =>
                          navigate(
                            `/learn/${group.courseId}?scrollTo=${bm.scrollId}`,
                          )
                        }
                      >
                        <svg
                          width="13"
                          height="13"
                          viewBox="0 0 14 14"
                          fill="none"
                          aria-hidden="true"
                          className="bm-page__bm-icon"
                        >
                          <path
                            d="M3 2h8v10L7 9.5 3 12V2z"
                            stroke="currentColor"
                            strokeWidth="1.4"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <div className="bm-page__bm-text">
                          <span className="bm-page__bm-name">{bm.name}</span>
                          {bm.description && (
                            <span className="bm-page__bm-desc">
                              {bm.description}
                            </span>
                          )}
                        </div>
                        <svg
                          width="13"
                          height="13"
                          viewBox="0 0 16 16"
                          fill="none"
                          aria-hidden="true"
                          className="bm-page__arrow"
                        >
                          <path
                            d="M6 3l5 5-5 5"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
